import { CryptoProfiles } from './cryptoprofiles';


export namespace User {
    export type FactoringRole = 'Debtor' | 'Client' | 'Factor' | 'Admin' | 'Platform';

    export enum Roles {
        Administrator = 'Administrator',
        Issuer = 'Issuer',
        Owner = 'Owner',
        NominalHolder = 'NominalHolder',
    }

    export interface Claim {
        Name: string;
    }

    export enum UserChangeStatusId {
        None = 1,
        WaitingConfirmation = 2,
    }

    type ClientProfileGroupResponse = Array<{ Uid: string, Name: string }>;

    export enum Permissions {
        AdminCompanyRead = 'AdminCompany.Read',
        AdminCompanyOperator = 'AdminCompany.Operator',
        AdminCompanyDecisionMaker = 'AdminCompany.DecisionMaker',
        IssuerRead = 'Issuer.Read',
        IssuerOperator = 'Issuer.Operator',
        IssuerDecisionMaker = 'Issuer.DecisionMaker',
        OwnerRead = 'Owner.Read',
        OwnerOperator = 'Owner.Operator',
        OwnerDecisionMaker = 'Owner.DecisionMaker',
        OwnerReadIssueParticipation = 'Owner.Read.IssueParticipation',
        OwnerOperatorIssueParticipation = 'Owner.Operator.IssueParticipation',
        OwnerDecisionMakerIssueParticipation = 'Owner.DecisionMaker.IssueParticipation',
    }

    export interface Profile {
        CompanyUid: string;
        CompanyINN: string;
        CompanyKPP: string;
        CompanyOGRN: string;
        CompanyFullName: string;
        CompanyShortName: string;

        BusinessRole: FactoringRole;
        BusinessRoles: FactoringRole[];
        UserPermissionGroups: Claim[];
        UserPermissions: Claim[];
        Permissions: Permissions[] | null;
        ParticipantsDltKeys: string[];
    }

    export interface BappProfile extends Profile {
        FIO: string;
        UserName: string;
        IconDataUrl: string;
        UserCryptoProfiles: CryptoProfiles.UserCryptoProfile[];
        ProcessTemplateCodes: string[];
    }

    export type PaymentStatuses = 'Undefined' | 'ForPay' | 'Paid' | 'ForPayRenewal' | 'Blocked';

    export interface CoProfile extends Profile {
        Uid: string | null;
        IndividualUid: string | null;
        FirstName: string | null;
        MiddleName: string | null;
        Surname: string | null;
        FullName: string | null;
        INN: string | null;
        Login: string | null;
        NotificationEmail: string | null;
        PhoneNumber: string | null;
        SignerType: 0 | 1 | 2 | null;
        IsWarrantIssuer: boolean | null;
        IsWarrantRevoker: boolean | null;
        UserChangeStatusId: UserChangeStatusId | null;
        IsCompanyAdmin: boolean | null;
        IsDfaIssuer: boolean | null;
        IsDfaOwner: boolean | null;
        IsNominalHolder: boolean | null;
        CreateDate: Date | null;
        BlockedOIS: boolean | null;
        ClientProfileGroups: ClientProfileGroupResponse | null;
        AgentRegistrationTurnedOn: boolean | null;
        PlatformOnboardingProductOrderUid: string | null;
        PlatformOnboardingProductOrderStatusCode: string | null;
        TwoFactorEnabled: boolean | null;
        IsFirstAgent: boolean;
    }

    export type IndividualInfo = Pick<CoProfile, 'Surname' | 'FirstName' | 'MiddleName' | 'INN'> & {
        SNILS: string;
    };

    export interface ClaimResponse {
        Type: string | null;
        Value: string | null;
    }

    export interface DFAProfile {
        Uid: string;
        UserName: string | null;
        FIO: string | null;
        ClientUid: string;
        CompanyUid: string;
        ClientINN: string | null;
        ClientKPP: string | null;
        ClientOGRN: string | null;
        ClientProfileOisKey: string | null;
        ClientShortName: string | null;
        ClientOfficeUrl: string | null;
        UserPermissions: ClaimResponse[] | null;
        Permissions: Permissions[] | null;
        BlockedOIS: boolean;
        ClientProfileGroups: ClientProfileGroupResponse;
    }
}
